// src/services/adminLogService.ts
import { supabase } from '../supabaseClient';

export async function logAdminAction(
  action: string,
  description: string,
  details?: Record<string, any>
) {
  try {
    const backendUrl = process.env.REACT_APP_BACKEND_URL || 'http://localhost:3000';
    
    await fetch(`${backendUrl}/admin/logs`, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        action,
        description,
        details: details || null,
      }),
    });
  } catch (err) {
    console.error('Failed to log admin action', err);
  }
}